
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/___bot_or_not",
      function () {
        return require("private-next-pages/___bot_or_not.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/___bot_or_not"])
      });
    }
  